import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavPeopleInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || text_colorTextSecondary}
      fillRule="evenodd"
      d="M5.192 6.646a1.938 1.938 0 1 1 3.875 0 1.938 1.938 0 0 1-3.875 0ZM7.13 3.208a3.438 3.438 0 0 0-3.008 5.103 5.25 5.25 0 0 0-.766.482c-.907.69-1.814 1.875-1.814 3.766 0 1.57.461 2.718 1.008 3.516.882 1.289 2.453 1.535 3.662 1.535h8.073c.619 0 1.386-.038 2.094-.391.925-.463 2.252-1.51 2.252-3.585 0-1.544-.574-2.659-1.157-3.385a5.196 5.196 0 0 0-.505-.545 3.115 3.115 0 1 0-5.53-.504c-.132.086-.253.18-.364.277-.199-.312-.43-.57-.66-.778a4.13 4.13 0 0 0-.342-.276A3.438 3.438 0 0 0 7.13 3.208Zm4.513 12.902V11.049l.045-.05c.269-.292.436-.474.626-.583a3.105 3.105 0 0 0 2.019.743c.564 0 1.095-.15 1.552-.414.126.113.272.26.419.442.409.51.827 1.303.827 2.447 0 1.286-.774 1.918-1.423 2.243-.373.186-.834.233-1.423.233h-2.642Zm-1.5-4.643a2.153 2.153 0 0 0-.733-1.654 2.685 2.685 0 0 0-.393-.293 3.424 3.424 0 0 1-1.887.564 3.425 3.425 0 0 1-1.951-.607l-.044.017c-.24.098-.557.255-.872.494-.61.463-1.221 1.237-1.221 2.571 0 1.257.364 2.11.746 2.669.433.633 1.305.882 2.424.882h3.93v-4.643Zm2.575-3.423a1.615 1.615 0 1 1 3.23 0 1.615 1.615 0 0 1-3.23 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavPeopleInactive
